import React from "react";
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";
import { OverLayLoaderForCurtain } from "./styled";

interface ICurtainOverlayLoaderProps {
    // Full-screen overlay above the curtain raiser (AgeGate's agree/decline refetch)
    // instead of filling its normal-flow parent (Menu's own loading state).
    fixed?: boolean;
}

export const CurtainOverlayLoader = ({ fixed }: ICurtainOverlayLoaderProps) => (
    <OverLayLoaderForCurtain fixed={fixed}>
        <Loader type="primary" size="large" />
    </OverLayLoaderForCurtain>
);
